export const buildClientConfig = (clientCredentials) => {
    const authMethod = clientCredentials.clientSecret
        ? 'client_secret_basic'
        : 'none';
    return {
        client_id: clientCredentials.clientId,
        client_secret: clientCredentials.clientSecret,
        token_endpoint_auth_method: authMethod,
    };
};
